import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import enTranslation from "./en.json";
import cnTranslation from "./cn.json";
import esTranslation from "./es.json";

const resources = {
  en: {
    translation: enTranslation,
  },
  cn: {
    translation: cnTranslation,
  },
  es: {
    translation: esTranslation,
  },
};

const supportedLanguages = ["en", "cn", "es"];

function detectLanguage() {
  const stored = localStorage.getItem("selectedLanguage");
  if (stored && supportedLanguages.includes(stored)) {
    return stored;
  }

  const browserLangs = navigator.languages || [navigator.language];
  for (const lang of browserLangs) {
    const code = lang.toLowerCase().split("-")[0];
    if (code === "zh") return "cn";
    if (supportedLanguages.includes(code)) return code;
  }

  return "en";
}

i18n.use(initReactI18next).init({
  resources,
  lng: detectLanguage(),
  fallbackLng: "en",
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
